// extracted by mini-css-extract-plugin
export default {"stats":"styles_stats__TGwO0","stats__filters":"styles_stats__filters__Mcffg"};